import { urls } from './site';
import type { NavLink, ServiceMenuItem } from '../types/site';

export const serviceMenuItems: ServiceMenuItem[] = [
  { label: 'Truck Collision', description: 'Body and panel repair after an accident', href: urls.collision },
  { label: 'Semi Trucks', description: 'Cab, hood and body collision repairs', href: urls.semi },
  { label: 'Box Trucks', description: 'Roofs, walls, floors and doors', href: urls.boxTruck },
  { label: 'Commercial Painting', description: 'Collision refinishing and commercial paint', href: urls.paint },
  { label: 'Trailer Body Repair', description: 'Collision and body repairs for trailers', href: urls.trailer },
  { label: 'RV Body & Roof Repair', description: 'Fiberglass, roof and body repairs', href: urls.rv },
  {
    label: 'Additional Services',
    description: 'Service bodies, liftgate body repairs, wraps, sandblasting, heavy equipment',
    href: '#capabilities',
  },
];

export const primaryNavLinks: NavLink[] = [
  { label: 'Fleet Repair', href: '#fleet' },
  { label: 'Our Work', href: '#work' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' },
];
